import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from '@starbucks-web/pattern-library/lib/components/heading';

import { usePdpContext } from '../pdp-provider';
import messages from './messages';

const formatText = (text, depth, idx) =>
  depth ? (
    text
  ) : (
    <span className="text-bold" key={idx}>
      {text}
    </span>
  );

const getSubItemStart = (depth) => formatText(depth ? ' (' : ' [', depth + 1);

const getSubItemEnd = (depth) => formatText(depth ? ')' : ']', depth + 1);

const formatIngredients = (ingredientsArray) => {
  const elements = [];
  const addItem = (item, idx, depth) => {
    // Ingredient items may have a period at the beginning of the string like
    // when that item is serving as a disclaimer statement.  We want to make
    // sure those items don’t get a comma prepended in order to avoid a comma
    // followed directly by a period.
    elements.push(
      formatText(
        idx && !item?.name?.startsWith('.') ? `, ${item.name}` : item.name,
        depth,
        idx
      )
    );

    if (item.children.length) {
      elements.push(getSubItemStart(depth));
      item.children.forEach((subItem, subIdx) =>
        addItem(subItem, subIdx, depth + 1)
      );
      elements.push(getSubItemEnd(depth));
    }
  };
  ingredientsArray.forEach((item, idx) => addItem(item, idx, 0));
  return elements;
};

export const Ingredients = () => {
  const ingredients = usePdpContext().sizeInfo?.selectedSize?.ingredients ?? [];
  const ingredientsElements = formatIngredients(ingredients);

  return (
    <div className="pb5" data-e2e="ingredientsSection">
      <Heading
        bottomBorder
        className="mb3 text-semibold"
        size="md"
        tagName="h2"
      >
        <FormattedMessage {...messages.ingredientsTitle} />
      </Heading>
      <p className="my1">
        {ingredients.length ? (
          ingredientsElements
        ) : (
          <FormattedMessage {...messages.nutritionNotAvailable} />
        )}
      </p>
    </div>
  );
};
